import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import homeBannerSection from './sections/home-banner';
import courseSection from './sections/course';
import articlesSection from './sections/articles';
import grantRecipientsSection from './sections/grant-recipients';

/** boilerplate specific sections */
init();
modalSection();
headerSection();
homeBannerSection();
courseSection();
articlesSection();
grantRecipientsSection();

/** additional scripts */
const accordians = document.querySelectorAll('.accordian');
accordians.forEach(accordian => {
  accordian.addEventListener('click', event => {
    const content = accordian.querySelector('.accordian-content');
    const symbol = accordian.querySelector('.accordian-title .symbol');
    if (content) {
      content.classList.toggle('minimised');
      symbol.innerHTML = (symbol.innerHTML === '+' ? '-' : '+');
    }
  });
});

/** card clicks */
const linkCards = document.querySelectorAll('button.card');
if (linkCards) linkCards.forEach(link => {
  link.addEventListener('click', event => {
    const target = link.querySelector('a.button');
    if (target) target.click();
  });
});


// WEBPACK FOOTER //
// ./source/scripts/main.js